import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Manus",
  category: AgentCategory.ASSISTANT,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#4890E5",
  description: "Assign long-running async tasks and return to completed work via smart follow-ups in Dart",
  descriptionMarkdown: `## Overview

Delegate work to Manus directly from Dart. When you assign a task, Dart creates a Manus task, links you to the live Manus thread, and keeps using that same thread when you leave follow-up comments on the Dart task.

This keeps the conversation and context in one place, so Manus can continue the work instead of starting over each time.

## Setup guide

1. Create a Manus API key in [Manus API Integration settings](https://manus.im/app/agents#settings/integrations/api)
2. Open Dart settings, go to Agents, and choose Manus
3. Paste your Manus API key
4. Copy the Manus webhook URL from Dart
5. Paste it into your [Manus webhook settings](https://manus.im/app#settings/integrations/api)
6. Assign a task to Manus from Dart`,
  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "Manus API key",
      placeholder: "Your Manus API key",
      validate: validateIsNotEmpty,
    },
    {
      key: "webhook",
      type: "webhook",
    },
  ],
};

export default config;
